const getImageSrc = (image: string | undefined, extension: string | undefined) => {
  let src: string
  if (image !== null && extension !== 'LINK') {
    src = 'data:image/png;base64,' + image
  } else if (image !== null && extension === 'LINK') {
    src = atob(image !== undefined ? image : '')
  } else {
    src = ' '
  }
  return src
}

export default getImageSrc
